import { List, Datagrid, TextField, EmailField, EditButton, DeleteButton,
         Edit, SimpleForm, TextInput, Create, FunctionField, BooleanField, 
         SelectField,
         SelectInput, required} from 'react-admin';


const roleChoice = [
  { id: 'PLAYER', name: 'player' },
  { id: 'ADMIN', name: 'admin' },
];

const progressChoice = [
  { id: 'NOT_STARTED', name: 'Not started' },
  { id: 'PRE_EXPERIMENT', name: 'Pre expt' },
  { id: 'DOCUMENTATION_INTRO', name: 'Documentation Intro' },
  { id: 'EXPERIMENT', name: 'Expt' },
  { id: 'DOCUMENTATION_REVIEW', name: 'Documentation Review' },
  { id: 'WEBSITE1', name: 'Web1' },
  { id: 'WEBSITE2', name: 'Web2' },
  { id: 'POST_EXPERIMENT', name: 'Post expt' },
  { id: 'END', name: 'End' },
]

export const UserList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <BooleanField source="is_active" />
      <EmailField source="email" />
      <TextField source="full_name" />
      <TextField source="affiliation" />
      <SelectField source="role" choices={roleChoice}/>
      <SelectField source="progress_step" choices={progressChoice} />
      <FunctionField source="updated_at" 
        render={
          record => {
            return new Date(record.updated_at + "Z").toLocaleString(undefined, {timeZoneName: "shortOffset"});
          }
        }
      />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const UserEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="email" validate={required()} />
      <SelectInput source="role" choices={roleChoice} validate={required()} />
      <TextInput source="full_name" />
      <TextInput source="affiliation" />
      <TextInput source="password" validate={required()} />
      <TextInput source="confirm_password" validate={required()} />
    </SimpleForm>
  </Edit>
);

export const UserCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <SelectInput source="role" choices={roleChoice} validate={required()}/>
      <TextInput source="email" validate={required()} />
      <TextInput source="full_name" />
      <TextInput source="affiliation" />
      <TextInput source="password" validate={required()}/>
      <TextInput source="confirm_password" validate={required()}/>
    </SimpleForm>
  </Create>
);
